import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

const Container = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  marginBottom: theme.spacing(2),
}));

export default Container;
